module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Thin-b4b37a1192c03a8151fcf628e3543b38.woff2";